import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormInputViewerService } from '../../form-input-viewer.service';

@Component({
    selector: 'password-input',
    templateUrl: './input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordInputComponent{

	constructor(
		public inputService: FormInputViewerService
	){}
}
